/**
 * Round leaderboard button (bar-chart icon) — v2 chip-style.
 *
 * Yellow/gold body so it pairs with the score chip's gold; uses the same
 * bevel stack as {@link createHelpButton} (drop shadow → dark rim → main
 * fill → top highlight → faded white inner stroke).
 */

import { Container, Graphics } from '../../vendor/pixi.min.mjs';
import { paintCircleButton } from './shared.js';

const SIZE = 60;
const BG_COLOR = 0xfbbf24;
const BAR_COLOR = 0x3b1670;

/**
 * @param {number} x — centre x
 * @param {number} y — centre y
 * @param {() => void} onTap
 * @returns {Container}
 */
export function createLeaderboardButton(x, y, onTap) {
    const btn = new Container();
    btn.eventMode = 'static';
    btn.cursor = 'pointer';
    btn.x = x;
    btn.y = y;

    const chip = paintCircleButton({ size: SIZE, color: BG_COLOR });
    btn.addChild(chip);

    const barW = 7;
    const gap = 4;
    const baseY = 11;
    const bars = [
        { h: 12 },
        { h: 20 },
        { h: 15 },
    ];
    const totalW = bars.length * barW + (bars.length - 1) * gap;
    let bx = -totalW / 2;
    for (const bar of bars) {
        const icon = new Graphics();
        icon.roundRect(bx, baseY - bar.h, barW, bar.h, 2);
        icon.fill(BAR_COLOR);
        btn.addChild(icon);
        bx += barW + gap;
    }

    btn.on('pointertap', onTap);
    btn.on('pointerover', () => { btn.scale.set(1.06); });
    btn.on('pointerout',  () => { btn.scale.set(1.0);  });
    btn.on('pointerdown', () => { btn.scale.set(0.94); });
    btn.on('pointerup',   () => { btn.scale.set(1.06); });
    return btn;
}
